import React from "react";
import Header from "../ui/Header";
import { FaAngleRight } from "react-icons/fa6";
import Footer from "../ui/Footer";

export default function Blog() {
  return (
    <div>
      {/* Header */}
      <Header />
      {/* Blog content container */}
      <main>
        {/* Heading image and content */}
        <header className="mb-8 flex flex-col bg-gray-100 pb-8">
          <img
            src="/persons/man-boxing-1.jpg"
            alt="Man boxing"
            className="mb-8 block h-auto max-w-full object-cover md:max-h-[40vh] md:object-cover"
          />

          {/* Header image content */}
          <div className="px-4">
            <span className="mb-4 block font-medium uppercase">
              February 21, 2024
            </span>
            <h1 className="mb-10 text-xl font-semibold uppercase">
              The rose that grew from concreate
            </h1>
            <p className="mb-10 text-sm">
              Does where you come from determine what you deserve? Is it where
              you're from or where you're going that matters most?
            </p>
            <div className="group flex items-center gap-2">
              <button className="text-xl font-medium uppercase text-black transition duration-300">
                Read More
              </button>
              <FaAngleRight
                color="black"
                className="transition-all duration-300 group-hover:translate-x-2"
              />
            </div>
          </div>
        </header>

        {/* Main content */}
        <main className="px-4">
          {/* Tab container */}
          <div className="mb-8 flex items-start gap-2 text-xl uppercase">
            {/* Tab 1 button */}
            <button className="flex-grow border border-gray-200 px-4 py-2">
              Boxing
            </button>
            {/* Tab 2 button */}
            <button className="flex-grow border border-gray-200 px-4 py-2">
              Lookbooks
            </button>
          </div>

          {/* Image and content frid items */}
          <div className="mb-8 grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-x-2 lg:grid-cols-3">
            {/* Image and content container */}
            <div>
              <img
                src="/persons/man-boxing-1.jpg"
                alt="Man boxing"
                className="mb-2 block w-full object-cover"
              />
              {/* Content container */}
              <div className="font-light">
                <span className="mb-2 block">April 29, 2024</span>
                <h1 className="uppercase">Devin Hanley, Camp Notes</h1>
              </div>
            </div>
            {/* Image and content container */}
            <div>
              <img
                src="/persons/man-boxing-1.jpg"
                alt="Man boxing"
                className="mb-2 block w-full object-cover"
              />
              {/* Content container */}
              <div className="font-light">
                <span className="mb-2 block">April 29, 2024</span>
                <h1 className="uppercase">Devin Hanley, Camp Notes</h1>
              </div>
            </div>
            {/* Image and content container */}
            <div>
              <img
                src="/persons/man-boxing-1.jpg"
                alt="Man boxing"
                className="mb-2 block w-full object-cover"
              />
              {/* Content container */}
              <div className="font-light">
                <span className="mb-2 block">April 29, 2024</span>
                <h1 className="uppercase">Devin Hanley, Camp Notes</h1>
              </div>
            </div>
            {/* Image and content container */}
            <div>
              <img
                src="/persons/man-boxing-1.jpg"
                alt="Man boxing"
                className="mb-2 block w-full object-cover"
              />
              {/* Content container */}
              <div className="font-light">
                <span className="mb-2 block">April 29, 2024</span>
                <h1 className="uppercase">Devin Hanley, Camp Notes</h1>
              </div>
            </div>
            {/* Image and content container */}
            <div>
              <img
                src="/persons/man-boxing-1.jpg"
                alt="Man boxing"
                className="mb-2 block w-full object-cover"
              />
              {/* Content container */}
              <div className="font-light">
                <span className="mb-2 block">April 29, 2024</span>
                <h1 className="uppercase">Devin Hanley, Camp Notes</h1>
              </div>
            </div>
            {/* Image and content container */}
            <div>
              <img
                src="/persons/man-boxing-1.jpg"
                alt="Man boxing"
                className="mb-2 block w-full object-cover"
              />
              {/* Content container */}
              <div className="font-light">
                <span className="mb-2 block">April 29, 2024</span>
                <h1 className="uppercase">Devin Hanley, Camp Notes</h1>
              </div>
            </div>
            {/* Image and content container */}
            <div>
              <img
                src="/persons/man-boxing-1.jpg"
                alt="Man boxing"
                className="mb-2 block w-full object-cover"
              />
              {/* Content container */}
              <div className="font-light">
                <span className="mb-2 block">April 29, 2024</span>
                <h1 className="uppercase">Devin Hanley, Camp Notes</h1>
              </div>
            </div>
            {/* Image and content container */}
            <div>
              <img
                src="/persons/man-boxing-1.jpg"
                alt="Man boxing"
                className="mb-2 block w-full object-cover"
              />
              {/* Content container */}
              <div className="font-light">
                <span className="mb-2 block">April 29, 2024</span>
                <h1 className="uppercase">Devin Hanley, Camp Notes</h1>
              </div>
            </div>
          </div>

          {/* Pagination button */}
          <div className="mb-12 flex items-center justify-center text-black">
            {/* Button 1 */}
            <button className="flex h-6 w-6 items-center justify-center border-b border-black bg-gray-200 p-5">
              1
            </button>
            {/* Button 2 */}
            <button className="flex h-6 w-6 items-center justify-center border-black p-5">
              2
            </button>
            {/* Button 3 */}
            <button className="flex h-6 w-6 items-center justify-center border-black p-5">
              3
            </button>
            {/* Next button */}
            <button className="flex items-center justify-center border border-gray-200 p-3">
              <img src="/icons/next.png" alt="Next" className="h-3 w-3" />
            </button>
          </div>
        </main>
        {/* Footer component */}
        <Footer />
      </main>
    </div>
  );
}
